export const styles = {
  modal: {
    maxWidth: "520px",
    minWidth: { xs: "90%", sm: "448px" },
    padding: "24px 0 !important",
    borderRadius: "16px",
  },

  closeButton: {
    position: "absolute",
    top: "16px",
    right: "16px",
    padding: 0,
    zIndex: 2,
    color: "#393939",

    ":hover": {
      border: "none",
    },
  },
};
